import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import PropTypes from 'prop-types';
import { wsActions } from '../../../redux/ws/actions';
import { chatActions } from '../../../redux/chat/actions';

const SocketErrorNotification = ({ setValue, messages }) => {
  const error = useSelector(state => state.ws.error);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (error) {
      if (messages && messages.length) {
        const lastUserMsg = [...messages].reverse().find(m => m.message_type === 'user');
        if (lastUserMsg) {
          if (setValue) setValue(lastUserMsg.text);
          dispatch(chatActions.deleteUserMessageById(lastUserMsg.id));
          dispatch(chatActions.stopTyping());
        }
      }
    }
  }, [error, messages, setValue, dispatch]);

  // Auto-hide error after 5 seconds
  React.useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        dispatch(wsActions.clearSocketError());
      }, 5000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [error, dispatch]);

  if (!error) return null;

  const errorMessage = typeof error === 'string' ? error : error.description || JSON.stringify(error);

  return (
    <div style={{
      position: 'fixed',
      top: '16px',
      left: '50%',
      transform: 'translateX(-50%)',
      maxWidth: '90%',
      width: '320px',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#D32F2F',
      color: 'white',
      padding: '12px 16px',
      borderRadius: '8px',
      fontSize: '14px',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
      gap: '8px',
    }}
    >
      <ErrorIcon label="error" primaryColor="white" />
      <span>{errorMessage}</span>
      <button
        type="button"
        onClick={() => dispatch(wsActions.clearSocketError())}
        style={{
          marginLeft: 'auto',
          background: 'transparent',
          border: 'none',
          color: 'white',
          fontSize: '16px',
          cursor: 'pointer',
        }}
      >
        ✕
      </button>
    </div>
  );
};

SocketErrorNotification.propTypes = {
  setValue: PropTypes.func,
  messages: PropTypes.arrayOf(PropTypes.object),
};

SocketErrorNotification.defaultProps = {
  setValue: undefined,
  messages: [],
};

export default SocketErrorNotification;
